import { render } from "./MWorkOrders.vue?vue&type=template&id=23767633&scoped=true"
import script from "./MWorkOrders.vue?vue&type=script&lang=js"
export * from "./MWorkOrders.vue?vue&type=script&lang=js"

import "./MWorkOrders.vue?vue&type=style&index=0&id=23767633&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23767633"]])

export default __exports__